<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="datastories-wrapper">
    <div class="datastories-view has-side-bars">
      <div class="presentation-wrap">
        <h2 class="datastory-title">{{ $t('datastory_title') }}</h2>
        <h3 class="datastory-desc">{{ $t('datastory_desc') }}</h3>
        <div class="datastory-desc2">
          <span class="datastory-ext">{{ $t('datastory_desc2') }} <a :href="urlToShare" class="datastory-link">{{ urlToShare }}</a></span>
        </div>
      </div>
      <div class="filter-selector">
        <div
          v-for="option in filtersArray"
          :key="option"
          class="filter-op"
          :class="option === defaultFilter && 'selected'"
          @click="changeSelectedFilter(option)"
        >
          {{ option === 'all' ? $t('all_op') : $t('dtst_' + option) }}
        </div>
      </div>
      <Loader v-if="loading" />
      <div v-else-if="dataStoriesCards" class="datastory-cards">
        <DataStoryCard
          v-for="(card, i) in filteredDatastories"
          :key="i"
          :card="card"
          type="extended"
        />
      </div>
      <div v-else class="cms-error">{{ $t('not_cms') }}</div>
    </div>
  </div>
</template>

<script>
import Loader from '../components/Loader.vue'
import DataStoryCard from '../components/cover/DataStoryCard'
import { getCMSDatastories } from '@/services/graphql'

export default {
  components: { Loader, DataStoryCard },
  props: {},
  data() {
    return {
      filtersArray: [/*'all',*/ 'interactiveapps', 'reports', 'pdfdocuments', 'observatory'],
      defaultFilter: 'interactiveapps',
      loading: true,
      filteredDatastories: null,
      isProduction: process?.env?.NODE_ENV === 'production' ? true : false
    }
  },
  computed: {
    urlToShare() {
      return window.location.origin + '/' + this.$store.state.i18n.lang + '/search?source=DATASTORIES'
    }
  },
  asyncComputed: {
    dataStoriesCards() {
      return getCMSDatastories(this.$store.state.i18n.lang).then(resp =>
        resp.sort((a, b) => {
          return a.score - b.score
        })
      )
    },
  },
  watch: {
    dataStoriesCards() {
      this.filteredDatastories = this.dataStoriesCards.filter(
        el => el.typeSelected && el.typeSelected.indexOf(this.defaultFilter) !== -1
      )
      this.loading = false
    },
    defaultFilter() {
      this.filteredDatastories = this.dataStoriesCards.filter(
        el => el.typeSelected && el.typeSelected.indexOf(this.defaultFilter) !== -1
      )
      setTimeout(() => {
        this.loading = false
      }, 1)
    }
  },
  methods: {
    changeSelectedFilter(fil) {
      if (this.defaultFilter !== fil) {
        this.filteredDatastories = null
        this.loading = true
        this.defaultFilter = fil
      }
    },
  },
}
</script>

<style lang="stylus" scoped>
.datastories-wrapper
  flex: 1 1 0%
  background-color: rgba($bcn-dark-blue-gray, 0.05)

.datastories-view
  padding-top: vw(70px)
  padding-bottom: vw(35px)

  .mobile &
    padding-top: vw(50px)
    padding-bottom: vw(50px)

  .presentation-wrap
    margin-right: auto
    margin-bottom: vw(70px)
    margin-left: auto
    margin-right: auto
    max-width: vw(900px)

    .mobile &
      margin-bottom: vw(50px)

  .datastory-title
    m-font-size(32, 44)
    color: #000
    text-align: center
    font-weight: 600
    margin-block-start: 0
    margin-block-end: vw(20px)

  .datastory-desc
    m-font-size(16, 25)
    color: $grey-dark
    text-align: center
    margin-block-start: 0
    margin-block-end: 0
    
  .datastory-desc2
    display: flex
    gap: vw(5px)
    justify-content: center
    margin-top: vw(10px)
    
    .datastory-ext
      m-font-size(14, 20)
      color: $grey-dark
      text-align: center
      
    .datastory-link
      m-font-size(14, 20)
      color: $corporate_color
      text-align: center

  .filter-selector
    display: flex
    overflow-x: auto
    margin-bottom: vw(50px)
    gap: vw(20px)

    .filter-op
      m-font-size(16, 25)
      padding: vw(10px)
      border-bottom: 3px solid transparent
      color: $grey-dark
      white-space: nowrap
      cursor: pointer

      .mobile &
        padding: vw(6px) vw(12px)
        width: min-content
        text-align: center

      &:hover
        border-bottom-color: $grey

      &.selected
        border-bottom-color: $corporate_color
        color: $corporate_color
        cursor: default

  .datastory-cards
    $gap = vw(20px)
    display: flex
    flex-wrap: wrap
    gap: $gap

    .mobile &
      flex-direction: column

    .datastory-card
      $percentage = percentage((1 / 4))
      $gap-percentage = 1 + 1 / 3
      $width = "calc(%s - (%s / %s))" % ($percentage $gap $gap-percentage)
      flex: 0 0 $width

      .mobile &
        flex: 1 1 0%

  .cms-error
    m-font-size(20, 26)
    display: flex
    justify-content: center
    margin-top: vw(20px)
    padding-bottom: vw(30px)
    font-weight: 400
</style>